import * as React from 'react';
import { Box } from 'theme-ui';
import type { RouteComponentProps } from '@reach/router';

import Container from '../../01_atoms/Container/Container';
import Header from '../../02_molecules/Header/Header';
import LiveTrainings from './LiveTrainings';

export default function LiveTrainingsPage(
  _props: RouteComponentProps,
): React.ReactElement {
  return (
    <>
      <Header showButton="menu" theme="light" />
      <Box sx={{ mt: 4, pb: 6 }}>
        <Container>
          <LiveTrainings showBalance />
        </Container>
      </Box>
    </>
  );
}
